module.exports = __webpack_public_path__ + "5dedc92b0ec7bf6d7a7ce6d185671158.png";